module.exports = __webpack_public_path__ + "img/9.febd325b.jpeg";